module.exports = __webpack_public_path__ + "img/plus_btn.c835bc16.png";